function n(n){return(r={},t)=>{const o={};for(const c in n)o[c]=n[c](r[c],t);return o}}export{n as combineReducers};
